var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpsOnTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44 44",
    style: {
      enableBackground: "new 0 0 44 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_235_3_",
    transform: "translate(-315 -520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180_3_",
    transform: "translate(315 520)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8_3_",
    fill: "#FFFFFF",
    cx: 22,
    cy: 22,
    r: 22
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#82A996",
    d: "M19.9,26.2l-6.6,6.3c-1.1,1.1-3.2,0.2-3-1.3c0.1-0.1,0.1-0.4,0.3-0.6l5.2-12.5l4.4-10.7c0.7-1.7,3.1-1.7,3.8,0 l4.4,10.7l5.2,12.5l0,0c0.7,1.7-1.6,3.1-3,1.8L24,26.2C23,25.1,21.2,25.1,19.9,26.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsOnTarget);
export default __webpack_public_path__ + "static/media/gps-on-target.292ba940.svg";
export { ForwardRef as ReactComponent };